import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import { Typography } from "antd";
import config from "../../../../config";

const baseUrl = config.baseUrl;
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    paddingTop: 10,
    paddingRight: 60,
    paddingLeft: 60,
    paddingBottom: 100,
    fontFamily: "Times-Roman",
  },
  section: {
    padding: 10,
    flexGrow: 1,
  },
  title: {
    fontSize: 12,
    marginTop: 5,
    marginBottom: 20,
    textAlign: "center",
    fontWeight: "bold",
    fontFamily: "Times-Bold",
  },
  textareaLabel: {
    fontSize: 12,
    textAlign: "justify",
    marginBottom: 8,
    lineHeight: 1.5,
  },
  headerTable: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
    paddingTop: 10,
    paddingRight: 10,
    paddingLeft: 10,
    marginBottom: 20,
  },
  logoColumn: {
    width: "75%",
    alignItems: "center",
  },
  banner: {
    width: "100%",
    height: 40,
  },
  infoColumn: {
    width: "220px",
    borderWidth: 1,
    borderColor: "#000",
  },
  codeRow: {
    padding: 3,
    borderBottomWidth: 1,
    borderBottomColor: "#000",
  },
  codeText: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    textAlign: "center",
  },
  dateVersionRow: {
    flexDirection: "row",
    height: "25px",
  },
  dateCell: {
    width: "55%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 3,
    paddingLeft: 8,
    justifyContent: "center",
  },
  versionCell: {
    width: "45%",
    padding: 3,
    paddingLeft: 8,
    justifyContent: "center",
  },
  checkboxContainerHorizontal: {
    flexDirection: "column",
    marginTop: 7,
  },
  checkboxGroup: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 5,
  },
  checkbox: {
    width: 12,
    height: 12,
    borderWidth: 1,
    borderColor: "#000",
    marginRight: 5,
    backgroundColor: "#fff",
    justifyContent: "center",
    alignItems: "center",
  },
  checkboxText: {
    fontSize: 10,
  },
  signatureContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 5,
  },
  signature: {
    width: 130,
    height: 70,
    marginBottom: 5,
    alignSelf: "center",
  },
  signatureLine: {
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    marginTop: 10,
  },
  signatureText: {
    fontSize: 12,
    textAlign: "left",
    fontFamily: "Times-Roman",
  },
  signatureImage: {
    width: 130,
    height: 70,
    marginBottom: 5,
  },
  text: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    textAlign: "left",
  },

  checkboxContainerColumns: {
    flexDirection: "row",
    justifyContent: "space-between",
  },

  checkboxColumn: {
    flexDirection: "column",
    flex: 1,
    paddingRight: 10,
  },
  // ...tus estilos existentes
  footerCodeContainer: {
    position: "absolute",
    bottom: 20,
    right: 40,
  },
  footerCode: {
    fontSize: 10,
    fontStyle: "italic",
    color: "#0D0D0D",
    fontFamily: "Times-Bold", // <-- Esta línea hace el texto en negrita
  },
});

const MyDocument = ({ formData }) => {
  // Validar que formData exista para evitar errores
  if (!formData) return null;

  return (
    <Document>
      <Page size="legal" style={styles.page}>
        <View fixed>
          <View style={styles.headerTable} fixed>
            <View style={styles.logoColumn}>
              <Image style={styles.banner} src={"Banner_membrete.png"} />
            </View>

            <View style={styles.infoColumn}>
              <View style={styles.codeRow}>
                <Text style={styles.codeText}>CÓDIGO: IR-F-113</Text>
              </View>
              <View style={styles.dateVersionRow}>
                <View style={styles.dateCell}>
                  <Text style={styles.text}>FECHA: 2020-07-14</Text>
                </View>
                <View style={styles.versionCell}>
                  <Text style={styles.text}>VERSIÓN: V-1</Text>
                </View>
              </View>
            </View>
          </View>
        </View>

        <Text style={{ ...styles.title, fontSize: 11, marginBottom: 5 }}>
          Fortalecimiento de la Reincorporación Económica y Social
        </Text>
        <Text style={styles.title}>
          AUTORIZACIÓN DE USO, REPRODUCCIÓN, CESIÓN DERECHOS DE AUTOR DE PROPIA
          IMAGEN Y OTROS - ADULTOS
        </Text>

        {/* Sección de Identificació del proyecto */}
        <View style={styles.section}>
          <Text style={styles.textareaLabel}>
            Yo, {formData?.nombre_participante || ""}, identificado con Codigo
            SIR {formData.id_participante || ""}, de{" "}
            {formData?.fuente === "App"
              ? formData?.nacionalidad
              : formData?.municipio || ""}
            , autorizo de manera libre y espontánea a la Agencia para la
            Reincorporación y Normalización, en adelante ARN y a la Organización
            de las Naciones Unidas para la Alimentación y la Agricultura en
            adelante FAO, para que haga uso de:
          </Text>

          <View style={styles.questionSection}>
            <View style={styles.checkboxContainerColumns}>
              {/* Primera columna */}
              <View style={styles.checkboxColumn}>
                {[
                  { key: "uso_nombre", label: "Nombre" },
                  { key: "uso_fotos_videos", label: "Fotografías/Videos" },
                  { key: "uso_frases", label: "Frases" },
                  {
                    key: "uso_declaraciones",
                    label: "Declaraciones Testimoniales",
                  },
                ].map((item) => (
                  <View key={item.key} style={styles.checkboxGroup}>
                    <View style={[styles.checkbox]}>
                      {formData?.autorizaciones?.includes(item.key) && (
                        <Text
                          style={{
                            color: "#000",
                            fontSize: 8,
                            textAlign: "center",
                          }}
                        >
                          X
                        </Text>
                      )}
                    </View>
                    <Text style={styles.checkboxText}>{item.label}</Text>
                  </View>
                ))}
              </View>

              {/* Segunda columna */}
              <View style={styles.checkboxColumn}>
                {[
                  { key: "uso_imagen", label: "Imagen" },
                  { key: "uso_entrevista", label: "Entrevista" },
                  {
                    key: "uso_archivo_audiovisual",
                    label: "Imagen de archivo audiovisual",
                  },
                  { key: "uso_otro", label: "Otro" },
                ].map((item) => (
                  <View key={item.key} style={styles.checkboxGroup}>
                    <View style={[styles.checkbox]}>
                      {formData?.autorizaciones?.includes(item.key) && (
                        <Text
                          style={{
                            color: "#000",
                            fontSize: 8,
                            textAlign: "center",
                          }}
                        >
                          X
                        </Text>
                      )}
                    </View>
                    <Text style={styles.checkboxText}>{item.label}</Text>
                  </View>
                ))}
              </View>
            </View>
          </View>

          <Text style={styles.textareaLabel}>
            {" "}
            Tomadas(os) o producidas(os) el/los días {formData?.dia || ""} del
            mes {formData?.mes || ""} del presente año, con ocasión del
            proyecto, evento, actividad, etc. en medios de comunicación, redes
            sociales y/o en eventos públicos que tengan por objeto divulgar
            asuntos relacionados con el objeto del proyecto FRES de la ARN y
            FAO, para uso no comercial, conforme a las disposiciones contenidas
            en el artículo 9 de la Ley Estatutaria 1581 de 2012, el artículo 7
            del Decreto 1377 de 2013 compilado en el artículo 2.2.2.25.2.4. del
            Decreto 1074 de 2015 y las demás normas aplicables, reconozco que he
            sido informado que, como titular de la información tengo derecho a
            conocer, actualizar y rectificar, suprimir o revocar la autorización
            otorgada para el tratamiento sobre los datos personales, junto con
            el registro de datos personales de referencia realizado por este u
            otros medios, autoriza a la ARN y a la FAO para la recolección,
            almacenamiento y uso de los mismos en el marco de las finalidades
            antes descritas.
          </Text>

          <Text style={styles.textareaLabel}>
            De acuerdo con lo anterior se otorga a la ARN y la FAO licencia para
            el uso de la imagen, lo cual incluye su reproducción en todas sus
            modalidades, incluso para difusión audiovisual, comunicación
            pública, distribución y, en general, cualquier tipo de explotación
            que de estas imágenes o fotografías se pueda realizar por cualquier
            medio conocido o por conocer, así como las modificaciones.
          </Text>

          <Text style={styles.textareaLabel}>
            La presente autorización se otorga a título gratuito, es decir que
            no generará compensación económica alguna a mi favor. De igual
            manera, desisto de cualquier tipo de acción judicial, en contra de
            la Agencia para la Reincorporación y Normalización, y la
            Organización de las Naciones Unidas para la Alimentación y la
            Agricultura por este concepto. Dado en la ciudad de{" "}
            {formData?.fuente === "App"
              ? formData?.nacionalidad
              : formData?.municipio || ""}
            a los {formData?.dia || ""} días del mes de {formData?.mes || ""}{" "}
            del año {formData?.anio_firma || ""}.
          </Text>

          <Text style={styles.textareaLabel}>
            Dado en la ciudad de{" "}
            {formData?.fuente === "App"
              ? formData?.nacionalidad
              : formData?.municipio || ""}
            a los {formData?.dia || ""} días del mes de {formData?.mes || ""}{" "}
            del año {formData?.anio_firma || ""}.
          </Text>
        </View>

        <View style={styles.signatureContainer}>
          <View style={[styles.signature, { width: "100%" }]}>
            {formData?.firma_participante &&
            formData.firma_participante.trim() !== "" ? (
              <Image
                style={styles.signatureImage}
                src={`${
                    baseUrl + formData.firma_participante
                  }?t=${Date.now()}`}
              />
            ) : (
              <View
                style={[
                  styles.signatureImage,
                  {
                    justifyContent: "center",
                    alignItems: "center",
                    borderWidth: 0, // Sin borde
                  },
                ]}
              >
                <Text style={{ color: "#888", fontSize: 12 }}>
                  {" "}
                  {/* Tamaño más pequeño */}
                  Firma no disponible
                </Text>
              </View>
            )}

            <View style={[styles.signatureLine, { width: "50%" }]} />
            <Text style={styles.signatureText}>
              {formData?.nombre_participante || ""}
            </Text>
          </View>
        </View>

        <View style={styles.footerCodeContainer}>
          <Text style={styles.footerCode}>
            Código Único: {formData?.codigo_pdf || "N/A"}
          </Text>{" "}
        </View>
      </Page>
    </Document>
  );
};

const PdfAlmacenarAutorizacionImagen = ({ formData }) => {
  return <MyDocument formData={formData} />;
};

export default PdfAlmacenarAutorizacionImagen;
